
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Legal = lazy(() => import('../pages/legal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/portfolio',
    element: <Portfolio />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/legal',
    element: <Legal />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
